import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-semibold" }
const _hoisted_2 = { class: "font-semibold" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3" }, "Вы точно хотите продолжить?", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_modal = _resolveComponent("new-modal")!

  return (_openBlock(), _createBlock(_component_new_modal, {
    title: _ctx.getTitle,
    overflow: false,
    loading: _ctx.loading,
    onSubmit: _ctx.onSubmit,
    onCancel: _ctx.onCancel
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createTextVNode(" Вы открепляете дочернее направление "),
        _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.isChild ? _ctx.parent : _ctx.child), 1),
        _createTextVNode(" от родителя "),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.isChild ? _ctx.child : _ctx.parent || '-'), 1),
        _createTextVNode(". ")
      ]),
      _hoisted_3
    ]),
    _: 1
  }, 8, ["title", "loading", "onSubmit", "onCancel"]))
}